import React from "react";

const TooltipWrapper = ({ children, title, placement = "top" }) => {
  const positionClasses = {
    top: "bottom-full left-1/2 -translate-x-1/2 mb-2",
    bottom: "top-full left-1/2 -translate-x-1/2 mt-2",
    left: "right-full top-1/2 -translate-y-1/2 mr-2",
    right: "left-full top-1/2 -translate-y-1/2 ml-2",
  };

  const arrowClasses = {
    top: "top-full left-1/2 -translate-x-1/2 border-t-gray-900",
    bottom: "bottom-full left-1/2 -translate-x-1/2 border-b-gray-900",
    left: "left-full top-1/2 -translate-y-1/2 border-l-gray-900",
    right: "right-full top-1/2 -translate-y-1/2 border-r-gray-900",
  };

  return (
    <div className="relative group inline-block">
      {children}
      
      <div
        className={`absolute z-[100] whitespace-nowrap px-3 py-1.5 text-xs font-bold text-white bg-gray-900 rounded-lg 
        shadow-xl opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none
        ${positionClasses[placement]}`}
      >
        {title}
        
        <div
          className={`absolute border-4 border-transparent ${arrowClasses[placement]}`}
        ></div>
      </div>
    </div>
  );
};

export default TooltipWrapper;